var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-details",class:{ active: _vm.active },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"text-sm font-weight-normal"},[_vm._v(" Szczegóły ")]),_c('a-icon',{staticClass:"btn-details__chevron ml-0",attrs:{"icon":"Chevron"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }